import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { CheckForUpdateService } from '../../core/service-worker/check-for-update.service-worker.service';

@Component({
  selector: 'app-version-upgrade-header',
  templateUrl: './version-upgrade-header.component.html',
  styleUrls: ['./version-upgrade-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NzAlertModule, NzButtonModule, NzWaveModule],
})
export class VersionUpgradeHeaderComponent {
  constructor(private checkForUpdateService: CheckForUpdateService) {}

  isShow = computed(() => {
    return this.checkForUpdateService.showVersionUpgradeHeader();
  });

  onUpgradeClick() {
    window.location.reload();
  }
}
